/**
 * Application Configuration
 * App-wide constants and configuration values
 */

export const STORAGE_KEYS = {
  AUTH_TOKEN: "auth_token",
  THEME_STORAGE: "theme-storage",
  UNREAD_COUNTS: "unread_counts",
  CHAT_STATE: "chat-state",
} as const;

export const DEFAULT_TOKEN =
  "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyb2xlcyI6WyJBRE1JTiJdLCJzaXBBY2NvdW50IjoiVFNpcEFjY291bnQoaWQ6MTIsIHVzZXJuYW1lOnBodW5nZGEsIHBhc3N3b3JkOktEQ0AxMjM0LCBzZXJ2ZXI6c2lwLmtpZG8udm4sIHBvcnQ6NTA2MCwgcHJvdG9jb2w6U0lQLCBkaXNwbGF5TmFtZTpExrDGoW5nIEFuaCBQaOG7pW5nLCBjcmVhdGVkQXQ6MTc1NDk4NDIzMjAwMCwgdXBkYXRlZEF0OjE3NTQ5ODQyMzIwMDAsIGNyZWF0ZWRCeTowLCB1cGRhdGVkQnk6MCkiLCJleHAiOjE3OTU4MzU3OTgsInVzZXJJZCI6MTAwNDMsInVzZXJuYW1lIjoicGh1bmdkYSIsInRhZ3MiOiIifQ.zitHDJWfXyfk31TRlK5CU5vFB2G4yF9BC4R04265O6Q";

export const DEFAULT_THEME = "light";

/**
 * @deprecated Use getEnvironmentConfig() from adapters/environment instead
 * This is kept for backward compatibility only
 */
export const DEFAULT_SOCKET_URL =
  import.meta.env.VITE_SOCKET_URL ?? "http://localhost:9061";

